<template>
  <div class="gallery-preview">
    <Swiper
      class="gallery-preview-swiper"
      :modules="swiperModules"
      :slides-per-view="1"
      :space-between="0"
      :loop="images.length > 1"
      :navigation="{
        prevEl: prevBtn,
        nextEl: nextBtn,
      }"
    >
      <SwiperSlide v-for="(img, idx) in images" :key="idx">
        <img v-if="useProxy" :src="imageUrlWithProxy((img as any)[urlField], 376, 230)" alt="Room image" loading="lazy" />
        <img v-else :src="urlField" alt="Room image" loading="lazy" />
      </SwiperSlide>
    </Swiper>
    <button v-if="images.length > 1" ref="prevBtn" class="gallery-preview__control prev" aria-label="Previous image">
      <span class="icon icon-chevron-left"></span>
    </button>
    <button v-if="images.length > 1" ref="nextBtn" class="gallery-preview__control next" aria-label="Next image">
      <span class="icon icon-chevron-right"></span>
    </button>
    <div v-if="images.length > 1" class="gallery-preview__total text-caption" @click="toggleMoreInfo">
      +{{images.length - 1}} {{$t('photos')}}
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper/modules'
import { imageUrlWithProxy } from '~/utils/imageproxy'
import 'swiper/css'
import 'swiper/css/navigation'

const emit = defineEmits(['toggleMoreInfo'])

const {
  images,
  urlField,
  useProxy
} = defineProps({
  images: { type: Array, default: () => [] },
  urlField: { type: String, default: '' },
  useProxy: { type: Boolean, default: true }
})

const swiperModules = [Navigation]
const prevBtn = ref<HTMLElement | null>(null)
const nextBtn = ref<HTMLElement | null>(null)

function toggleMoreInfo() {
  emit('toggleMoreInfo')
}
</script>

<style lang="scss" scoped>
.gallery-preview {
  position: relative;

  .gallery-preview-swiper {
    width: 100%;
    height: 100%;

    :deep(.swiper-slide) {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  // Hide default swiper navigation arrows (using custom buttons)
  :deep(.swiper-button-prev),
  :deep(.swiper-button-next) {
    display: none;
  }

  .gallery-preview__control {
    position: absolute;
    z-index: 1;
    background: transparent;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    font-size: 32px;
    color: var(--white);
    text-shadow: 0 0 10px #000;
    cursor: pointer;
    border: none;
    padding: 0;
    &.prev {
      left: 6px;
    }
    &.next {
      right: 6px;
    }
  }
  .gallery-preview__total {
    position: absolute;
    right: 8px;
    bottom: 12px;
    padding: 6px 11px;
    border-radius: 15px;
    background-color: var(--dark-grey);
    color: var(--white);
    text-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    opacity: 0.7;
    &:hover {
      opacity: 1;
      cursor: pointer;
    }
  }
}
</style>
